import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollTop from "./ScrollTop";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ScrollTop />
    </div>
  );
}